var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassenger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.2,429.3c0-4.5,0-9.2,0-13.7c0.2-1.2,0.4-2.3,0.6-3.5c1.9-11.1,2.9-22.5,5.8-33.3c10.9-41,33.6-74.3,67.4-100 c5.3-4,10.8-7.6,16.3-11.4c-0.6-0.9-1.1-1.7-1.7-2.4c-21.4-29-28.8-61.2-22.1-96.5c4.5-24.3,16.1-45.1,33.7-62.5 c15.9-15.7,34.8-26.4,56.7-31.3c6.9-1.6,13.9-2.4,20.9-3.5c4.8,0,9.6,0,14.4,0c3.3,0.4,6.6,0.9,10,1.4 c35.4,5.3,63.6,22.7,83.1,52.4c25.6,39.1,27.6,80.5,7,122.6c-3.4,6.9-8,13.3-12.2,20.1c0.6,0.4,1.4,1.1,2.4,1.7 c14.9,9.2,28.3,20.4,40,33.4c22.7,25.3,37.5,54.7,44,88.2c1.6,8.1,2.4,16.3,3.5,24.5c0,4.5,0,9.2,0,13.7 c-1.9,5.8-5.8,9.7-11.6,11.6c-115.5,0-231,0-346.6,0C77,439,73.1,435.1,71.2,429.3z M164,191.9c-0.5,50.2,40.7,91.8,91.5,92.3 c50.5,0.5,91.6-40.2,92.5-91.6c0.9-50-40.9-92.1-91.7-92.5C205.8,99.7,164.6,140.8,164,191.9z M356,305.8 c-8.2-5.3-16-10.3-23.6-15.5c-2.5-1.7-4.3-1.4-6.6,0.3c-15.2,11-32.1,18-50.5,20.8c-32.5,5-62.3-2.1-89.2-21.1 c-2-1.4-3.5-1.6-5.7-0.4c-36.6,21-61.4,51.6-73.6,92c-2.9,9.5-4.3,19.6-6.6,29.9c2.4,0,3.7,0,5,0c47.1,0,94.1,0,141.1,0.1 c2.7,0,4.6-0.7,6.6-2.7c33.3-33.4,66.6-66.7,100-100.1C353.6,308.4,354.4,307.5,356,305.8z M411.3,411.7 c-3.2-31.8-14.9-60-34.7-84.3c-28.2,28.2-56.3,56.3-84.3,84.3C331.5,411.7,371.3,411.7,411.3,411.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.e4732005511156d05a0c74181306384f.svg";
export { ForwardRef as ReactComponent };